const SUPER_ADMIN_FLAG = 'super_admin';

const permissionAliasMap: Record<string, string[]> = {
    /** 历史别名：曾用于兼容旧版演员列表访问权限（Dramas_Actors → Dramas_Actors_Review），
     *  演员列表页已下线，此处暂无需映射的别名。 */
};

const aliasToSourceMap: Record<string, string> = Object.entries(permissionAliasMap).reduce(
    (acc, [source, aliases]) => {
        aliases.forEach((alias) => {
            acc[alias] = source;
        });
        return acc;
    },
    {} as Record<string, string>,
);

const expandAliasPermissions = (permissions: string[] = []): string[] => {
    const expanded = new Set<string>(permissions);

    permissions.forEach((permission) => {
        const aliases = permissionAliasMap[permission];
        if (aliases) {
            aliases.forEach((alias) => expanded.add(alias));
        }
        const source = aliasToSourceMap[permission];
        if (source) {
            expanded.add(source);
        }
    });

    return Array.from(expanded);
};

const collapseAliasPermissions = (permissions: string[]): string[] => {
    const collapsed = new Set<string>();

    permissions.forEach((permission) => {
        const source = aliasToSourceMap[permission];
        collapsed.add(source || permission);
    });

    return Array.from(collapsed);
};

const mapPermissionsForDisplay = (permissions: string[] = []): string[] => {
    const display = new Set<string>();

    permissions.forEach((permission) => {
        const aliases = permissionAliasMap[permission];
        if (aliases?.length) {
            aliases.forEach((alias) => display.add(alias));
            return;
        }

        display.add(permission);
    });

    return Array.from(display);
};

const hasPermission = (permissions: string[] = [], required: string): boolean => {
    if (!required) {
        return false;
    }

    if (permissions.includes(SUPER_ADMIN_FLAG)) {
        return true;
    }

    if (permissions.includes(required)) {
        return true;
    }

    const source = aliasToSourceMap[required];
    if (source && permissions.includes(source)) {
        return true;
    }

    const aliases = permissionAliasMap[required];
    if (aliases) {
        return aliases.some((alias) => permissions.includes(alias));
    }

    return false;
};

export { collapseAliasPermissions, expandAliasPermissions, hasPermission, mapPermissionsForDisplay };
